export const getCreateDeviceDepParams = (
  deviceId?: string,
  releaseName?: string
) => ({
  artifactname: releaseName,
  device: deviceId,
});
